import React, { useRef } from 'react';
import RagnaDataTable from '../ReactComponents/RagnaDataTable';
import axios from 'axios';
import { ajax_api, getAccess } from '../../Globals';
import { ordinal_suffix_of } from '../ReactGlobals';
import { useOutlet, Outlet, useOutletContext } from 'react-router-dom';
import Select from 'react-select';
import { useForm } from "react-hook-form";
import { ErrorMessage } from '@hookform/error-message';
import { Helmet } from 'react-helmet';

const Councils = props => {
    //datatable options
    const [refreshTable] = useOutletContext();
    const table_columns = [
        { display: "Name", col: "CouncilNo", customValue: e => ordinal_suffix_of(e.CouncilNo) + " SP Council" },
        { display: "Period", col: "Period", dontOrder: true },
        { display: "Officials", col: "Officials" },
        { display: "Committees", col: "Committees" },
        { display: "SP Items", col: "Items" }
    ];
    const search_columns = [
        { display: "Name", col: "Name" }
    ];
    const outlet = useOutlet();
    const editInput = useRef(null);

    const { register, handleSubmit, getValues, reset, formState: { errors } } = useForm();

    const onSave = (data, mOpen, refresh) => {
        var f = new FormData();
        Object.keys(data).forEach(k => f.append(k, data[k] ?? ""))

        axios.post(`${ajax_api}councils/edit`, f, { withCredentials: true }).then(_ => {
            mOpen();
            refresh();
        }).catch(e => alert(e));
    }

    return <>
        <Helmet>
            <title>LTS | Manage Councils</title>
        </Helmet>
        {
            outlet != null ? <Outlet /> :
                <RagnaDataTable
                    refreshTable={refreshTable}
                    title="Council Status"
                    columns={table_columns}
                    s_columns={search_columns}
                    defaultOrder={false}
                    maxPagination={8}
                    generalSearch={true}
                    defaultOrderCol="ID"
                    url={ajax_api + "councils/get-table"}
                    actions={[
                        {
                            hideIf: !getAccess(38),
                            action: "modal", display: "Edit",
                            body: (d, mOpen, refresh) => {
                                var periodSplit = d.Period.replace(/ /g, '').split("-");
                                return <form onSubmit={handleSubmit(d => onSave(d, mOpen, refresh))} key={d.Id}>
                                    <input type="hidden" value={d.Id} {...register("Id")} />
                                    Council Number
                                    <div className="d-flex align-items-center">
                                        <select key={`${d.Id}-${d.CouncilNo}`} className="form-select w-25 me-2" {...register("CouncilNo")} defaultValue={d.CouncilNo}>
                                            {
                                                Array.from({ length: 30 }, (_, i) => { return <option value={i + 1}>{ordinal_suffix_of(i + 1)}</option> })
                                            }
                                        </select>
                                        <div>
                                            SP Council
                                        </div>
                                    </div>
                                    Period From
                                    <input type="number" defaultValue={periodSplit[0]} {...register("PeriodFrom", { required: "This field is required" })} className="form-control" />
                                    Period To
                                    <input type="number" defaultValue={periodSplit[1]} {...register("PeriodTo", { required: "This field is required" })} className="form-control" />
                                </form>
                            },
                            title: "Edit Data",
                            footer: (_, mOpen, refresh) => <button className="ro-button" onClick={handleSubmit(e=>onSave(e,mOpen,refresh))}>
                                <span>Save</span>
                            </button>,
                            reset: reset
                        },
                        {
                            hideIf: !getAccess(39),
                            action: "url_confirm", display: "Delete",
                            content: d => `${ajax_api}councils/delete/${d.Id}`,
                            body: d => `Are you sure you want to delete "${ordinal_suffix_of(d.CouncilNo)} SP Council" ?`, title: "Delete Data"
                        },
                        //{
                        //    action: "modal", display: "Cust",
                        //    content: d => { return { title: "title modal", body: "full name: " + d.full_name, footer: <span>footer</span> } }
                        //},
                    ]}
                />
        }
    </>
}

export default Councils;